module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " do ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "Wybrano ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "Kliknij, aby zako\u0144czy\u0107 wyb\xF3r zakresu dat",
  "maximumDate": "Ostatnia dost\u0119pna data",
  "minimumDate": "Pierwsza dost\u0119pna data",
  "next": "Dalej",
  "previous": "Wstecz",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Wybrana data: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Wybrany zakres: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknij, aby rozpocz\u0105\u0107 wyb\xF3r zakresu dat",
  "todayDate": function todayDate(args) {
    return "Dzisiaj, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Dzisiaj wybrano ".concat(args.date);
  }
};